
import { Helmet } from 'react-helmet-async';
import CarouselListView from 'src/sections/carousel/view/CarouselListView';

export default function CarouselListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Galeria</title>
      </Helmet>

      <CarouselListView />
    </>
  );
}
